<div class="message-builder-container">
  <!-- Loading Spinner -->
  <div class="spinner-container" *ngIf="isLoadingMessage">
    <div class="spinner">
      <i class="fa fa-spinner fa-spin"></i>
      <span class="loading-text">Loading message...</span>
    </div>
  </div>

  <div class="builder-layout" [ngClass]="{'loading': isLoadingMessage}">
    <div class="builder-panel">
      

      <div class="builder-content">
        <app-rcs-sms 
          *ngIf="activeTab === MessageType.SMS"
          [message]="currentMessage"
          (messageChange)="onMessageChange($event)">
        </app-rcs-sms>

        <app-rcs-text 
          *ngIf="activeTab === MessageType.TEXT"
          [message]="currentMessage"
          (messageChange)="onMessageChange($event)">
        </app-rcs-text>

        <app-rcs-rich-card 
          *ngIf="activeTab === MessageType.STANDALONE"
          [message]="currentMessage"
          (messageChange)="onMessageChange($event)">
        </app-rcs-rich-card>

        <app-rcs-carousel 
          *ngIf="activeTab === MessageType.CAROUSEL"
          [message]="currentMessage"
          (messageChange)="onMessageChange($event)">
        </app-rcs-carousel>
      </div>
      <div class="button-group">
        <button class="btn btn-save" (click)="save()">Save</button>
        <button [disabled]="!hasClientAnyRcsApp" class="btn btn-send" (click)="send()">Send RCS</button>
      </div>
    </div>

    <div class="preview-panel">       
      <app-preview [message]="currentMessage"></app-preview>
    </div>
  </div>

  <!-- JSON Export Modal -->
  <div class="json-modal" *ngIf="showJsonExport" (click)="closeJsonExport()">
    <div class="json-modal-content" (click)="$event.stopPropagation()">
      <div class="json-modal-header">
        <h3>JSON Configuration</h3>
        <button class="btn-close" (click)="closeJsonExport()">×</button>
      </div>
      <div class="json-modal-body">
        <pre class="json-content">{{ jsonConfig }}</pre>
      </div>
      <div class="json-modal-footer">
        <button class="btn btn-primary" (click)="copyToClipboard()">Copy to Clipboard</button>
        <button class="btn btn-secondary" (click)="closeJsonExport()">Close</button>
      </div>
    </div>
  </div>
</div>
